export const META_BM_ID = "1394447174339287";

export const AGENCY_EMAILS = [
  { role: "Lead Strategist", email: "john@smartmarketer.com" },
  { role: "Email Architect", email: "emailarchitect@smartmarketer.com" },
  { role: "Agency Operations", email: "agency@smartmarketer.com" },
];

export const CHANNELS = [
  {
    id: "meta",
    name: "Meta Ads",
    sub: "Facebook & Instagram · Business Manager",
    icon: "facebook",
    est: "≈ 2 min",
    span: "lg:col-span-7",
    accent: { color: "#1877F2", bg: "#EFF6FF", border: "#BFDBFE" },
    pills: [
      { value: META_BM_ID, label: "Partner ID", testId: "meta-bm-copy-button" },
    ],
    link: { href: "https://business.facebook.com/settings", label: "Open Meta Business Settings" },
    steps: [
      "Open Meta Business Settings at business.facebook.com/settings and make sure you're in your business portfolio.",
      "In the left sidebar go to Users → Partners, then click + Add and choose 'Add a new partner'.",
      "Paste our Partner Business ID — use the copy button above.",
      "Assign your ad account and your Facebook / Instagram page to the partner.",
      "Set both to 'View' access and send the request. That's it.",
    ],
  },
  {
    id: "google",
    name: "Google Ads",
    sub: "Manager account linking",
    icon: "target",
    est: "≈ 2 min",
    span: "lg:col-span-5",
    accent: { color: "#EA4335", bg: "#FEF2F2", border: "#FECACA" },
    pills: [
      { value: "agency@smartmarketer.com", label: "Our team", testId: "google-manager-email-button" },
    ],
    link: { href: "https://ads.google.com", label: "Open Google Ads" },
    steps: [
      "Keep an eye out for an invite email from Google Ads — sent on behalf of our team under agency@smartmarketer.com.",
      "In Google Ads, click Tools & Settings (wrench icon) → Setup → Access and security.",
      "Open the 'Managers' tab — our manager account request will be waiting there.",
      "Approve the request and our team is linked. You'll see Smart Marketer listed as a manager.",
    ],
  },
  {
    id: "klaviyo",
    name: "Klaviyo / Omnisend",
    sub: "Email & SMS platform",
    icon: "mail",
    est: "≈ 3 min",
    span: "lg:col-span-7",
    accent: { color: "#10B981", bg: "#ECFDF5", border: "#A7F3D0" },
    pills: [
      { value: "john@smartmarketer.com", label: "Invite", testId: "copy-email-button-john" },
      { value: "emailarchitect@smartmarketer.com", label: "Invite", testId: "copy-email-button-emailarchitect" },
      { value: "agency@smartmarketer.com", label: "Invite", testId: "copy-email-button-agency" },
    ],
    link: { href: "https://www.klaviyo.com", label: "Open Klaviyo" },
    steps: [
      "Log into Klaviyo (or Omnisend). In Klaviyo: click the avatar bottom-left → Settings → Users.",
      "Click 'Add new user'. In Omnisend it's under Store settings → Users → invite by email.",
      "Add all three agency emails from the list above.",
      "Set each role to 'Manager' (or 'Admin'), then send the invites.",
    ],
  },
  {
    id: "attribution",
    name: "Triple Whale / Northbeam",
    sub: "Attribution & insights",
    icon: "waves",
    est: "≈ 1 min",
    optional: true,
    span: "lg:col-span-5",
    accent: { color: "#8B5CF6", bg: "#F5F3FF", border: "#DDD6FE" },
    pills: [
      { value: "agency@smartmarketer.com", label: "Invite", testId: "copy-email-button-attribution" },
    ],
    links: [
      { href: "https://app.triplewhale.com", label: "Open Triple Whale", testId: "channel-open-triplewhale" },
      { href: "https://app.northbeam.com", label: "Open Northbeam", testId: "channel-open-northbeam" },
    ],
    note: "Optional — only needed if your strategist specifically asked for Triple Whale or Northbeam. Otherwise, skip this one.",
    steps: [
      "Log in to Triple Whale (app.triplewhale.com) or Northbeam (app.northbeam.com).",
      "Go to Settings → Team members (Northbeam: your team or user settings) and click 'Invite user'.",
      "Add agency@smartmarketer.com, pick the role 'Editor' or 'Admin', and send.",
    ],
  },
];
